import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import MaterialsTagsApi from '@/services/apiServiceModules/materialsTagsApi'
const materialsTagsApi = new MaterialsTagsApi()

export default class MaterialsTagsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.MATERIALS_TAGS, materialsTagsApi, {
			useCache: true,
		})
	}
}
